import axios from 'axios';
import { API_BASE_URL } from 'configs/AppConfig';
import { signOutSuccess } from 'store/slices/authSlice';
import store from '../store';
import { AUTH_TOKEN } from 'constants/AuthConstant';
import { notification } from 'antd';

const unauthorizedCode = [400, 401, 403];

const service = axios.create({
  baseURL: API_BASE_URL,
  timeout: 60000,
  withCredentials: true,
  headers: { Accept: 'application/json' },
});

const TOKEN_PAYLOAD_KEY = 'authorization';

// API Request interceptor
service.interceptors.request.use(async (config) => {
  const jwtToken = localStorage.getItem(AUTH_TOKEN) || null;
  if (jwtToken) {
    config.headers[TOKEN_PAYLOAD_KEY] = `Bearer ${jwtToken}`;
  }
  return config;
}, error => {
	// Do something with request error here
	notification.error({
		message: 'Error'
	})
	Promise.reject(error)
})

// API respone interceptor
service.interceptors.response.use( (response) => {
	return response.data
}, (error) => {
	if (!error.response) {
		notification.error({
			message: 'Network Error',
			description: 'Unable to connect to API server',
		})
		return Promise.reject(error);
	}

	let notificationParam = {
		message: ''
	}

	// Remove token and redirect 
	if (unauthorizedCode.includes(error.response.status)) {
		notificationParam.message = 'Authentication Fail'
		notificationParam.description = 'Please login again'
		localStorage.removeItem(AUTH_TOKEN)

		store.dispatch(signOutSuccess())
	}

	if (error.response.status === 404) {
		notificationParam.message = 'Not Found'
	}

	if (error.response.status === 500) {
		notificationParam.message = 'Internal Server Error'
	}
	
	if (error.response.status === 508) {
		notificationParam.message = 'Time Out'
	}

	// Laravel validation errors
	if (error.response.status === 422) {
		notificationParam.message = 'Помилка валідації';
		const payload = error.response.data || {};
		const serverMessage =
			(payload?.data && payload.data.message) ||
			payload?.message ||
			payload?.error ||
			null;

		const errorsObj = payload?.errors;
		if (serverMessage && errorsObj && typeof errorsObj === 'object') {
			const details = Object.values(errorsObj)
				.flat()
				.filter(Boolean)
				.slice(0, 5)
				.join(', ');
			notificationParam.description = details || serverMessage;
		} else if (serverMessage) {
			notificationParam.description = serverMessage;
		} else if (errorsObj && typeof errorsObj === 'object') {
			notificationParam.description = Object.values(errorsObj)
				.flat()
				.filter(Boolean)
				.slice(0, 5)
				.join(', ');
		}
	}

	notification.error(notificationParam)

	return Promise.reject(error);
});

export default service